import router from './router'
import store from './store'
// import { Message } from 'element-ui'
// import NProgress from 'nprogress' // progress bar
// import 'nprogress/nprogress.css' // progress bar style
import { getToken, getAccessToken, getRememberMe, getSessionRememberMe } from '@/auth' // get token from cookie
import {
    getStepRegister,
} from '@/auth'
// import { getDeviceId } from '@/auth' // get device from cookie
// import getPageTitle from '@/utils/get-page-title'

// NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['login', 'register', 'resetPassword', 'otherPage'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {

    // start progress bar
    // NProgress.start()

    // set page title
    // document.title = getPageTitle(to.meta.title)
    if (to.name == 'logout') {
        store.dispatch('login/logout')
    }

    // determine whether the user has logged in
    const hasToken = getToken()
    const hasAccessToken = getAccessToken()
    const hasCookieRememberMe = getRememberMe()
    const hasSessionRememberMe = getSessionRememberMe()
        // const hasDeviceId = getDeviceId()
        //  const id = getID()

    //  console.log('permit:', id, hasToken)
    // if (hasToken && hasDeviceId) {
    if (hasToken && hasAccessToken) {
        if (hasCookieRememberMe != 1 && hasSessionRememberMe != 1) {
            store.dispatch('login/logout')
        }
        // let params = {
        //     token: hasAccessToken
        // }

        // store.dispatch('permission/resetToken')

        // await store.dispatch('user/userToken', params).then(data=>{
        //     // this.users = data.result
        //     if (getToken() != undefined) {
        //        alert('login success');
        //        // this.$router.push({name:'home'})
        //     }
        //  }).catch(err=>{
        //     console.log(err)
        //     // alert('login fail');
        //  })
        if ((to.name === 'login' || to.name === 'register') && parseInt(getStepRegister()) !== 2) {
            next({ name: 'home' })
                // console.log(to.path)
                // if is logged in, redirect to the home page
                // NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
        } else {

            // determine whether the user has obtained his permission roles through getInfo
            // const hasRoles = store.getters.roles && store.getters.roles.length > 0

            //    console.log('permit hasrole: ', store.getters.roles)

            try {
                // console.log(to);
                // console.log(next);
                next()
                    // console.log(next);
                    // get user info
                    // note: roles must be a object array! such as: ['administrator'] or ,['developer','editor']
                    // const userInfo = await store.dispatch('permission/getInfo')

                // console.log("permit userinfo: ", userInfo)

                // store.commit('SET_ROLES', [userInfo.role])

                // // generate accessible routes map based on roles
                // const accessRoutes = await store.dispatch('permission/generateRoutes', [userInfo.role])

                // console.log(accessRoutes);

                // dynamically add accessible routes
                // router.addRoutes(accessRoutes)

                // await store.dispatch('permission/changeRoles')

                // hack method to ensure that addRoutes is complete
                // set the replace: true, so the navigation will not leave a history record
                // next({ ...to, replace: true })
            } catch (error) {
                console.log(error)
                    // remove token and go to login page to re-login
                    //  console.warn('set route error:', store.getters.roles)
                store.dispatch('permission/resetToken')
                    // Message.error(error || 'Has Error')
                next({
                        name: 'register',
                        query: { redirect: to.path }
                    })
                    // NProgress.done()
            }
        }
    } else {
        /* has no token*/
        if (whiteList.indexOf(to.name) !== -1) {
            // in the free login whitelist, go directly
            next()
        } else {
            // other pages that do not have permission to access are redirected to the login page.
            next({
                    name: 'login',
                    query: { redirect: to.path }
                })
                // NProgress.done()
        }
    }
})

router.afterEach(() => {
    // finish progress bar
    // NProgress.done()
})